import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const ROLES = {
  rm: { label: 'Sales / RM', user: 'Priya Raman' },
  analyst: { label: 'Research analyst', user: 'Daniel Tan' },
  admin: { label: 'Admin', user: 'Research Ops' },
} as const;

export type Role = keyof typeof ROLES;

type RoleState = { role: Role; setRole: (role: Role) => void };

// Demo-only role switcher (PRD section 3). The backend re-checks the role on every call.
export const useRoleStore = create<RoleState>()(
  persist((set) => ({ role: 'rm', setRole: (role) => { set({ role }); } }), { name: 'ocbc-demo-role' }),
);

export const getCurrentRole = (): Role => useRoleStore.getState().role;
